import axiosHelper from '../utils/axios';
import File from '../models/file';

export default (() => {
  const networkAssetPath = "/networkAsset/";
  
	async function createFile(file) {
    let data = new FormData();
    data.append('file', file, file.name);    
    
    const serializedFile = File.serialize(file);
    
    data.append(
      'fileDef',
      new Blob([JSON.stringify(serializedFile)], {
        type: 'application/json'
      })
    );
    
    try {
      const response = await axiosHelper.getNetworkAsset().post(`${networkAssetPath}files`, data);
      
      let serializedData = File.normalize(response.data);
      
      return serializedData;
    } catch (error) {
      throw error;
    }
  }

  async function getFile(href) {
    const response = await axiosHelper.getNetworkAsset().get(href);
    let serializedData = File.normalize(response.data);
    return serializedData;
  }

  async function getFileById(id) {
    const response = await axiosHelper.getNetworkAsset().get(`${networkAssetPath}file/${id}`);
    let serializedData = File.normalize(response.data);
    return serializedData;
  }
  
	return {
    createFile,
    getFile,
    getFileById,
  }

})();